import { makeStyles } from '@material-ui/core';

const baseCssBedStatus = makeStyles((theme) => ({
  rectIcon: {
    width: '1.25rem',
    height: '0.938rem',
    borderRadius: '0.281rem',
  },
  vacantText: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: '500',
    color: '#2e4469',
    margin: '0 0 0 0.625rem',
  },
  tabButton: {
    width: '10rem',
    height: '3.875rem',
    backgroundColor: '#538fff11',
    borderRadius: '0.75rem 0.75rem 0 0',
    fontFamily: 'NotoSans-Bold',
    fontSize: '1rem',
    fontWeight: '600',
    color: '#538fff88',
  },
  selectBtn: {
    backgroundColor: '#fff !important',
    fontWeight: 'bold !important',
    background: '#fff !important',
    color: '#538fff !important',
  },
  setting: {
    width: '7.188rem',
    height: '2.25rem',
    borderRadius: '0.625rem',
    background: '#538fff',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#fff',
    fontFamily: 'NotoSans-Medium',
  },
  inputText: {
    '& *': {
      padding: '0',
      margin: '0',
      border: '0',
    },
    fontFamily: 'NotoSans-Medium',
    height: '3.063rem',
    lineHeight: '3.063rem',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    backgroundColor: '#fff',
    paddingLeft: '1.25rem',
    color: '#2e4469',
    fontSize: '1rem',
    fontWeight: '500',
    '& .MuiInputBase-root': {
      fontFamily: 'NotoSans-Medium',
      color: '#2e4469',
    },
    '& :focus': {
      backgroundColor: 'unset',
    },
    '& :before': {
      content: 'none',
    },
    ':before': {
      content: 'none !important',
    },
    '& :after': {
      content: 'none',
    },
  },
  select: {
    '& .MuiSelect-iconOutlined': {
      color: '#538fff',
    },
  },

  statusText: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#7d86a9',
  },
}));

export { baseCssBedStatus };
